
import { useState } from 'react';
import '../App.css';

function Navbar({ aboutRef, skillsRef, projectsRef, contactRef }) {
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        console.log(isOpen);
        setIsOpen(!isOpen)
    };
    const handleScroll = (ref) => {window.scrollTo({top: ref.current.offsetTop-100, behavior: 'smooth'})};
    return (
        <div className="Navbar">
            <div className="Brand">
                <h5>neerajmalwal</h5>
            </div>
            <div className="Hamburger">
                <i class="fa fa-bars" onClick={toggle}></i>
            </div>
            {
                isOpen ?
                    <div className='Navbar-Items' style={{display: "flex"}}>
                        <div className='Navbar-Item' onClick={() => handleScroll(aboutRef)}>
                            About
                        </div>
                        <div className='Navbar-Item' onClick={() => handleScroll(skillsRef)}>
                            Skills
                        </div>
                        <div className='Navbar-Item' onClick={() => handleScroll(projectsRef)}>
                            Projects
                        </div>
                        <div className='Navbar-Item' onClick={() => handleScroll(contactRef)}>
                            Contact
                        </div>
                    </div>
                    :
                    <div className='Navbar-Items' style={{display: "none"}}>
                        <div className='Navbar-Item'>
                            About
                        </div>
                        <div className='Navbar-Item'>
                            Skills
                        </div>
                        <div className='Navbar-Item'>
                            Projects
                        </div>
                        <div className='Navbar-Item'>
                            Contact
                        </div>
                    </div>
            }
        </div>
    );
}

export default Navbar;
